import React from 'react';
import DashEstablishmentContainer from 'modules/dashboard/_common/DashEstablishmentContainer';
import RestaurantInventoryPage from 'modules/restaurant/inventory/RestaurantInventoryPage';

export default function DashRestaurantInventory() {
    return (
        <DashEstablishmentContainer title='Estoque'>
            <RestaurantInventoryPage />
        </DashEstablishmentContainer>
    );
}
